import React, { FC } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface FitbitDeeplinkProps extends ReduxProps {
  url: string;
}

const Deeplink = styled.a`
  -webkit-tap-highlight-color: transparent;
`;

const mapStateToProps = (state: any) => {
  const {
    deviceInfo: { phoneAppScheme = 'fitbit' }
  } = state.gallery;

  return {
    scheme: phoneAppScheme
  };
};

const GenericFitbitDeeplink: FC<FitbitDeeplinkProps> = ({ scheme, url, children }) => (
  <Deeplink href={`${scheme}://${url}`}>
    {children}
  </Deeplink>
);

export const FitbitDeeplink = connect(mapStateToProps)(GenericFitbitDeeplink);

interface PremiumUpsellDeeplinkProps {
  triggerFeature: string;
  triggerView: string;
}

export const PremiumUpsellDeeplink: FC<PremiumUpsellDeeplinkProps> = ({
  triggerFeature,
  triggerView,
  children
}) => (
  <FitbitDeeplink url={`upsell?trigger_feature=${triggerFeature}&trigger_view=${triggerView}`}>
    {children}
  </FitbitDeeplink>
);
